import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import apiService from "src/services/api.service";
import { PageEnum } from "src/helpers/Enums";
import SearchLine from "src/components/SearchLine";
import SearchNotFound from "src/components/SearchNotFound";
import Empty from "src/components/Empty";
import TagTable from "./TagTable";
import DeleteTag from "./DeleteTag";
import NewTag from "./NewTag";
import Pagination from "src/components/Pagination";

const TagManagement = () => {

    const [isNewTagOpen, setIsNewTagOpen] = useState(false);
    const [isUpdate, setIsUpdate] = useState(true);
    const [tagList, setTagList] = useState([])
    const [filteredTagList, setFilteredTagList] = useState([]);
    const [search, setSearch] = useState("");
    const [operationType, setOperationType] = useState();
    const [chosenTag, setChosenTag] = useState();
    const [isDeleteTagOpen, setIsDeleteTagOpen] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            apiService.getAllTags().then((response) => {
                setTagList(response.data)
            })
            setIsUpdate(false)
        }
    }, [isUpdate])

    useEffect(() => {
        const filtered = tagList?.filter((item) => {
            const itemName = item?.name?.toLowerCase?.() || '';
            const searchTerm = search?.toLowerCase?.() || '';
            return itemName.includes(searchTerm);
        });
        setFilteredTagList(filtered || []);
    }, [search, tagList])

    const handleOpenNewTag = (type, tag) => {
        setOperationType(type)
        setIsNewTagOpen(true)
        setChosenTag(tag)
    }

    const closeModal = () => {
        setIsNewTagOpen(false)
        setIsDeleteTagOpen(false)
        setIsUpdate(true)
    };

    const handleOpenDeleteTag = (tag) => {
        setIsDeleteTagOpen(true)
        setChosenTag(tag)
    }

    return (
        <div className={ "Page" }>
            <Header handleOpenNewTag={ handleOpenNewTag } setSearch={ setSearch } search={ search }></Header>
            { search && <SearchLine setSearch={ setSearch } search={ search }></SearchLine> }
            { filteredTagList?.length > 0 ?
                <div className={ "px-6 w-full h-full flex flex-col justify-between" }>
                    <TagTable handleOpenDeleteTag={ handleOpenDeleteTag }
                              handleOpenNewTag={ handleOpenNewTag } list={ filteredTagList }/>
                    <Pagination currentPage={ 1 } totalPages={ 1 } onPageChange={ () => {
                    } }/>
                </div> : search ?
                    <SearchNotFound title={ "No Tags Found" }
                                    description={ "No tags match your search. Review your keywords or filters to refine your results." }></SearchNotFound> :
                    <Empty handleNew={ handleOpenNewTag } title={ "No Tags Added Yet" }
                           description={ "Start by creating tags to categorize and manage your users more effectively." }
                           type={ "Tag" } menu={ PageEnum.LISTS }
                    ></Empty>
            }
            { isNewTagOpen && <NewTag setIsNewTagOpen={ setIsNewTagOpen } type={ operationType }
                                      tag={ chosenTag } close={ closeModal }/> }
            { isDeleteTagOpen &&
                <DeleteTag setIsDeleteTagOpen={ setIsDeleteTagOpen } id={ chosenTag?._id } name={ chosenTag?.name }
                           close={ closeModal }/> }
        </div>
    );
}

export default injectIntl(TagManagement);